import React from 'react';
import { generateColor, getInitials } from '../../utils/validations';

export const Initials = ({ firstName, lastName }) => {
  const initials = getInitials(firstName, lastName);
  const backGroundColor = generateColor(firstName);

  return (
    <h6
      className="rounded-full text-center w-10 h-10 leading-10"
      style={{ background: backGroundColor }}
    >
      {initials}
    </h6>
  );
};
